var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKandio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1550_774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.83609 8.63484C4.87936 7.08582 5.92962 5.54099 6.96029 3.98219C7.27216 3.51148 7.64974 3.16788 8.22312 3.10642C8.86502 3.03658 9.42581 3.21118 9.802 3.77128C10.1922 4.35234 10.3027 4.98927 9.91948 5.59826C9.20345 6.73243 8.45946 7.84985 7.69589 8.9519C6.83443 10.195 7.01903 11.1979 8.30144 12.0681C9.29016 12.7385 10.346 12.8265 11.3963 12.3097C12.4647 11.7832 13.0884 10.9088 13.1192 9.66565C13.1402 8.80943 13.5891 8.17809 14.2813 7.95601C15.0295 7.71576 15.7763 7.89874 16.1819 8.56081C16.6462 9.31925 16.5161 10.2048 16.3301 11.001C15.7274 13.5794 14.0296 15.3142 11.5179 15.8296C9.12934 16.3199 6.79527 15.81 5.13668 13.7135C4.86258 13.3671 4.69056 13.3433 4.44303 13.7303C4.09201 14.2764 3.70883 14.8044 3.32285 15.3282C2.91589 15.8813 2.14953 16.1006 1.40973 15.9008C0.972007 15.7807 0.506314 15.0153 0.503517 14.3756C0.496524 13.0738 0.502118 11.772 0.502118 10.4702C0.502118 7.54116 0.502118 4.61214 0.502118 1.68451C0.502118 0.582456 0.999977 0.00139973 1.93556 2.95861e-06C3.1886 -0.00139381 3.70883 0.491666 3.71163 1.70825C3.71722 4.00315 3.71303 6.29804 3.71303 8.59293L3.83609 8.63484Z",
    fill: "#0D1116"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1550_774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKandio);
export default __webpack_public_path__ + "static/media/kandio.a2d1c629a5263fd0b442b7f7e7f0b57e.svg";
export { ForwardRef as ReactComponent };